module.exports = __webpack_public_path__ + "static/images/backPack-img-bg.ae074c5.png";